import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowLeft, Sparkles, Home, Trees, Coffee, BookOpen, Gamepad2, Film, Shirt as ShirtIcon, Heart } from 'lucide-react';
export function BarndormatoryPage() {
  return <div className="min-h-screen font-sans" style={{
    backgroundColor: '#0D121D'
  }} data-id="element-248" data-mp="3pbjgttphcjgl">
      <Header data-id="element-249" data-mp="3te68num5i4ds" />

      <main data-id="element-250" data-mp="3tclei63r0ngg">
        {/* Hero Section with Barn Exterior */}
        <section className="relative pt-32 pb-32 overflow-hidden" style={{
        backgroundImage: 'linear-gradient(rgba(13, 18, 29, 0.75), rgba(13, 18, 29, 0.95)), url(https://cdn.magicpatterns.com/uploads/9mMW27wzQozbJryU4wuK2Q/HOlpD.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }} data-id="element-251" data-mp="26tsnix07wzg">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-252" data-mp="2dwmoa9u37c4h">
            <a href="/" className="inline-flex items-center text-slate-300 hover:text-white transition-colors mb-12" data-id="element-253" data-mp="2dyqp2iwovv0j">
              <ArrowLeft className="w-5 h-5 mr-2" data-id="element-254" data-mp="34amlsle8v0d9" />
              Back to Home
            </a>

            <div className="text-center max-w-4xl mx-auto" data-id="element-255" data-mp="2zbt92v6s7de5">
              <div className="mb-10 flex justify-center" data-id="element-256" data-mp="2za8ex6odpwgt">
                <img src="https://cdn.magicpatterns.com/uploads/8BjGD32ieUY3EYzqm5M2xt/Twice_Bourne_Logo-09.png" alt="TwiceBourne Barndormitory Holdings LLC Logo" className="max-w-sm w-full h-auto" data-id="element-257" data-mp="2uet2mj60s8mi" />
              </div>

              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-amber-500/20 border border-amber-400/40 text-amber-300 text-sm font-bold mb-6 uppercase tracking-wider" data-id="element-258" data-mp="3i1rd907gkmci">
                <Sparkles className="w-4 h-4" data-id="element-259" data-mp="26oylvqikxzwz" />
                Vision in Development
              </div>

              <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight drop-shadow-2xl" data-id="element-260" data-mp="22litx7hggnqm">
                TwiceBourne Barndormitory Holdings LLC
              </h1>

              <p className="text-xl md:text-2xl text-slate-200 mb-4 leading-relaxed drop-shadow-lg" data-id="element-261" data-mp="29199yo4ad7ys">
                Reimagining elderly care from the ground up.
              </p>
              <p className="text-lg text-slate-300 max-w-2xl mx-auto drop-shadow-lg" data-id="element-262" data-mp="1z3lbpo7h1ibv">
                A complete community — built indoors, designed with dignity,
                wrapped in the warmth of a barn.
              </p>
            </div>
          </div>
        </section>

        {/* Vision Statement */}
        <section className="py-20" data-id="element-263" data-mp="1bfv69yk9fawn">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-264" data-mp="1bcpfmevzg0yt">
            <div className="bg-white/5 backdrop-blur rounded-3xl border border-amber-500/20 p-10 md:p-14" data-id="element-265" data-mp="1geoilnnt8vv8">
              <div className="flex items-center gap-3 mb-6" data-id="element-266" data-mp="12eng63rwdgdn">
                <div className="w-12 h-12 rounded-full bg-amber-400/20 flex items-center justify-center" data-id="element-267" data-mp="16g8sno0irsnb">
                  <Heart className="w-6 h-6 text-amber-300" data-id="element-268" data-mp="nqn69j9p2x76" />
                </div>
                <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-269" data-mp="isvd6lxbd51e">
                  The Vision
                </h2>
              </div>
              <p className="text-lg md:text-xl text-slate-300 leading-relaxed mb-4" data-id="element-270" data-mp="wto8h8vfw45k">
                What if elderly care didn't feel like a facility — but felt like{' '}
                <span className="text-amber-300 font-semibold" data-id="element-271" data-mp="16phmkwot45pg">home</span>?
              </p>
              <p className="text-lg text-slate-400 leading-relaxed" data-id="element-272" data-mp="11rzjvo1dumpw">
                TwiceBourne Barndormitory is a bold concept to elevate elderly
                living into something truly special. From the outside, it
                resembles a classic barn nestled in the countryside. On the
                inside, it's a thriving, walkable community — where hallways
                become charming streets, private rooms become cozy houses, and
                every shared space invites connection, comfort, and joy.
              </p>
            </div>
          </div>
        </section>

        {/* Streets and Houses Section */}
        <section className="py-12" data-id="element-273" data-mp="28jklwesfv7g8">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-274" data-mp="2dc427jiiggoq">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-275" data-mp="2dcvt4h15xq8o">
              <div className="order-2 lg:order-1" data-id="element-276" data-mp="2iap03caaioa0">
                <div className="inline-block px-3 py-1 rounded-full bg-amber-400/20 text-amber-300 text-xs font-bold mb-4 uppercase tracking-wider" data-id="element-277" data-mp="1ll7nedcw41yt">
                  Hallways as Streets
                </div>
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-278" data-mp="1ul30wotx4920">
                  A Neighborhood Inside
                </h2>
                <p className="text-lg text-slate-300 leading-relaxed mb-4" data-id="element-279" data-mp="1zma9ur7srea9">
                  Wander down a softly lit lane lined with flower boxes and warm
                  lanterns. Wave to a neighbor. Stop for a chat. Inside
                  Barndormitory, every hallway is designed to feel like a
                  village street — and every door opens into a residence that
                  feels truly personal.
                </p>
                <p className="text-lg text-slate-400 leading-relaxed" data-id="element-280" data-mp="pmplsvyfcz3j">
                  Residents don't live in <em data-id="element-281" data-mp="knmh5cmcwuw3">rooms</em>. They live in{' '}
                  <span className="text-amber-300" data-id="element-282" data-mp="kmuyf2duyrn8">homes</span>.
                </p>
              </div>

              <div className="order-1 lg:order-2" data-id="element-283" data-mp="gnm4nxititro">
                <div className="rounded-3xl overflow-hidden border border-amber-500/20 shadow-2xl" data-id="element-284" data-mp="bn7ti6lx73pf">
                  <img src="https://cdn.magicpatterns.com/uploads/5qi2Zdb3D47qDz5RNEARTm/JP9If.jpg" alt="Indoor hallway designed as a community street" className="w-full h-auto" data-id="element-285" data-mp="6nlfhuy9pjfk" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Plaza Section */}
        <section className="py-12" data-id="element-286" data-mp="1w0yrm6cmgbr8">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-287" data-mp="3qiqbs32fbrik">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-288" data-mp="3v9q8b77ms7kj">
              <div data-id="element-289" data-mp="3vbta0oi5bp53">
                <div className="rounded-3xl overflow-hidden border border-amber-500/20 shadow-2xl" data-id="element-290" data-mp="3gku0nb9hkwkg">
                  <img src="https://cdn.magicpatterns.com/uploads/qr9UdnMMGJXk5jnfCK69T7/Barndormitory_Plaza.jpg" alt="Central plaza with fountain and skylight" className="w-full h-auto" data-id="element-291" data-mp="3ljnitgzpxbqy" />
                </div>
              </div>

              <div data-id="element-292" data-mp="43p2pe6fq66a">
                <div className="inline-block px-3 py-1 rounded-full bg-amber-400/20 text-amber-300 text-xs font-bold mb-4 uppercase tracking-wider" data-id="element-293" data-mp="42dqqr2u5s43">
                  The Heart of the Community
                </div>
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-294" data-mp="2osuxo4xxgtib">
                  A Plaza to Gather
                </h2>
                <p className="text-lg text-slate-300 leading-relaxed mb-4" data-id="element-295" data-mp="2sswu9zot2wqq">
                  At the center of it all is a grand indoor plaza — open,
                  bright, and filled with life. Sunlight streams through
                  skylights. A fountain bubbles gently. Greenery and flowers
                  bloom year-round.
                </p>
                <p className="text-lg text-slate-400 leading-relaxed" data-id="element-296" data-mp="2qc4sp08uvfhm">
                  This is where neighbors meet, friendships grow, and every day
                  feels a little bit like a celebration.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Amenities Grid */}
        <section className="py-20" data-id="element-297" data-mp="2cd52vp9lwujv">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-298" data-mp="27jsftjkksvt8">
            <div className="text-center mb-12" data-id="element-299" data-mp="27i92a0qb0yv5">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-3" data-id="element-300" data-mp="1jty7nfb7bvfb">
                A Complete Way of Life
              </h2>
              <p className="text-lg text-slate-400 max-w-2xl mx-auto" data-id="element-301" data-mp="1eveiz75845j9">
                Every amenity you'd find in a vibrant town — thoughtfully
                designed and right at home.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-302" data-mp="13aiyzrsg7n9s">
              <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-amber-400/50 transition-colors p-8" data-id="element-303" data-mp="13cm13a6vl6uv">
                <div className="w-14 h-14 rounded-full bg-amber-400/20 flex items-center justify-center mb-5" data-id="element-304" data-mp="1cbzbq66qk1h6">
                  <Home className="w-7 h-7 text-amber-300" data-id="element-305" data-mp="1h98z7gake32d" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-306" data-mp="1m0ha6grjlwhn">
                  Personal Residences
                </h3>
                <p className="text-slate-400" data-id="element-307" data-mp="1qysiuo63q0ya">
                  Private rooms reimagined as cozy homes, each with its own
                  character and warmth.
                </p>
              </div>

              <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-amber-400/50 transition-colors p-8" data-id="element-308" data-mp="201bhsx6rntf9">
                <div className="w-14 h-14 rounded-full bg-amber-400/20 flex items-center justify-center mb-5" data-id="element-309" data-mp="3fjpw6obqpo0c">
                  <Trees className="w-7 h-7 text-amber-300" data-id="element-310" data-mp="3bhuz5w0udwsd" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-311" data-mp="36j1hrsifplmx">
                  Central Plaza
                </h3>
                <p className="text-slate-400" data-id="element-312" data-mp="74fw1lreusv7">
                  A bright, open gathering space at the heart of the community.
                </p>
              </div>

              <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-amber-400/50 transition-colors p-8" data-id="element-313" data-mp="34p073n11mjt">
                <div className="w-14 h-14 rounded-full bg-amber-400/20 flex items-center justify-center mb-5" data-id="element-314" data-mp="3pip3o3krrdlr">
                  <ShirtIcon className="w-7 h-7 text-amber-300" data-id="element-315" data-mp="qsp1gxhysvcn" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-316" data-mp="m0xawmyt6pmi">
                  Laundromat
                </h3>
                <p className="text-slate-400" data-id="element-317" data-mp="2ni6vksjn4wpr">
                  Modern, accessible laundry facilities right within the
                  community.
                </p>
              </div>

              <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-amber-400/50 transition-colors p-8" data-id="element-318" data-mp="2wj4y16efkw68">
                <div className="w-14 h-14 rounded-full bg-amber-400/20 flex items-center justify-center mb-5" data-id="element-319" data-mp="2siuwc5xo8rx6">
                  <BookOpen className="w-7 h-7 text-amber-300" data-id="element-320" data-mp="31h6i9unlf1ja" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-321" data-mp="31fc7va9y6rtg">Library</h3>
                <p className="text-slate-400" data-id="element-322" data-mp="3g59pf7ddgj9o">
                  A quiet, welcoming space to read, learn, and reflect.
                </p>
              </div>

              <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-amber-400/50 transition-colors p-8" data-id="element-323" data-mp="3p5zjo6mzi1la">
                <div className="w-14 h-14 rounded-full bg-amber-400/20 flex items-center justify-center mb-5" data-id="element-324" data-mp="3k9hej5nqs18f">
                  <Coffee className="w-7 h-7 text-amber-300" data-id="element-325" data-mp="7m936qqyurc8" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-326" data-mp="cmdjogrvjm2g">
                  Activity Rooms
                </h3>
                <p className="text-slate-400" data-id="element-327" data-mp="3uv4gqw7n0cfh">
                  Dedicated spaces for hobbies, classes, crafts, and creative
                  expression.
                </p>
              </div>

              <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-amber-400/50 transition-colors p-8" data-id="element-328" data-mp="3l15d1srx0klf">
                <div className="w-14 h-14 rounded-full bg-amber-400/20 flex items-center justify-center mb-5" data-id="element-329" data-mp="3b5tybagibddo">
                  <Gamepad2 className="w-7 h-7 text-amber-300" data-id="element-330" data-mp="3g4ncz67j5aff" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-331" data-mp="3255jidjah8zq">Game Room</h3>
                <p className="text-slate-400" data-id="element-332" data-mp="373p6mh9mcqto">
                  Cards, board games, and fun gatherings to keep the spirit
                  young.
                </p>
              </div>

              <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-amber-400/50 transition-colors p-8 sm:col-span-2 lg:col-span-1" data-id="element-333" data-mp="17wijb2p6u7wn">
                <div className="w-14 h-14 rounded-full bg-amber-400/20 flex items-center justify-center mb-5" data-id="element-334" data-mp="12v2z1cuu45fb">
                  <Film className="w-7 h-7 text-amber-300" data-id="element-335" data-mp="ytr4qu10mw0s" />
                </div>
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-336" data-mp="1vjqo7jipfey5">
                  Mini Cinema
                </h3>
                <p className="text-slate-400" data-id="element-337" data-mp="1qkx5ncok8xr4">
                  Movie nights and shared screenings — the magic of the theater,
                  steps away.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Closing / Status Section */}
        <section className="pb-24" data-id="element-338" data-mp="b3wvsnjthrlt">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-339" data-mp="66detfvqj0q6">
            <div className="bg-gradient-to-br from-amber-500/20 via-amber-600/10 to-slate-900/40 backdrop-blur rounded-3xl border border-amber-400/30 p-12 text-center" data-id="element-340" data-mp="699bz1zrdldk">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-amber-400/20 border border-amber-300/40 text-amber-300 text-sm font-bold mb-6 uppercase tracking-wider" data-id="element-341" data-mp="2mtutfbcixezn">
                <Sparkles className="w-4 h-4" data-id="element-342" data-mp="2vn7xn9g1g311" />
                Concept Stage
              </div>

              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-343" data-mp="30k83pkcw15s5">
                The Future of Elderly Living
              </h2>
              <p className="text-lg text-slate-300 max-w-2xl mx-auto leading-relaxed" data-id="element-344" data-mp="3aixlld4saq8e">
                TwiceBourne Barndormitory Holdings LLC is currently in the
                vision and concept stage. We're building the foundation for a
                new standard of elderly care — one that honors dignity, fosters
                community, and feels like home.
              </p>
              <p className="text-base text-slate-400 mt-4" data-id="element-345" data-mp="1k8b6nu0an3r1">
                More updates coming as the vision takes shape.
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer data-id="element-346" data-mp="kx2hwn2bvtcm" />
    </div>;
}